import { useAuth } from "@/hooks/useAuth";
import { Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { logger } from "@/lib/logger";

type PublicRouteProps = {
  children: React.ReactNode;
};

export const PublicRoute = ({ children }: PublicRouteProps) => {
  const { user, profile, loading } = useAuth();
  const { t } = useTranslation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
        <div className="ml-4 text-lg">{t("common.loading")}</div>
      </div>
    );
  }

  if (user && profile) {
    logger.debug("Redirecting to dashboard - user authenticated", {
      role: profile.role,
    });
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};
